<template>

    <div class="order-error" v-if=" orderError != null ">

        <p>

            {{ orderError }}
        </p>
    </div>
</template>

<script>

    import { mapGetters } from 'vuex';
    import FontAwesomeIcon from '@fortawesome/vue-fontawesome';

    export default {

        name: 'delivery-fee-error',
        computed: {

            ...mapGetters({

                orderError          : 'merchant/orderError'
            })
        },
        components: {

            FontAwesomeIcon
        }
    }
</script>

<style scoped>


    .order-error {

        border-top: 1px solid #FDCEC6;
        border-bottom: 1px solid #FDCEC6;
        background-color: #FDCEC6;
        text-align: center;
        padding: 29px 20px;
        margin: 8px 0;
        color: rgb(52 58 64);
        font-size: 18px;
        font-weight: 500;
    }
</style>


